import { useClient } from 'hooks/useClient';
import { useQuery } from 'react-query';
import { resolveTokenV3 } from 'helpers/sessionContext';
import { useSession } from 'store/session';

export const useFetchInvitationToken = ({
  folder,
  document,
  team,
  invite,
  enabled,
}) => {
  const client = useClient({
    url: process.env.REACT_APP_API_V3,
    token: resolveTokenV3(),
  });

  const { team: defaultTeam } = useSession();

  const teamUUID = defaultTeam?.uuid as string;

  const resolvedToken = resolveTokenV3();

  const query = useQuery(
    ['get-invitation-token', document, resolvedToken],
    async () => {
      const response = await client.getInviteToken(
        team ?? teamUUID,
        folder,
        document,
        invite,
      );

      return response;
    },
    {
      enabled: Boolean(enabled && (team ?? teamUUID) && folder && document && resolvedToken),
    },
  );

  return { ...query };
};
